<template>
    <div class="mwap_signup">
        <div class="signup_body">
            <van-image v-if="mediaurl"  @click="del" class="video_close" width=".3rem" height=".3rem"
                       :src="require('assets/img/common/close.svg')"/>
            <div class="subtitle">上传图片</div>

            <div class="upload-box">
                <van-uploader :after-read="afterRead">
                    <div class="signup_up">
                        <div class="video_img">
                            <van-image v-if="mediaurl"  class="video" width="4rem" height="3rem"
                                       :src="mediaurl"/>
                            <van-image width="1.05rem" height="0.8rem" v-if="!mediaurl"
                                       src="https://img1.outnice.cn/images/2020/09/25/image_1601029420_v7MqV2Kv.png"/>
                        </div>
                        <div class="signup_notice">
                            <template v-if="!mediaurl">
                                点击，上传群二维码（不大于20MB）
                            </template>
                            <template v-else>
                                重新上传
                            </template>
                        </div>

                    </div>
                </van-uploader>
                <div class="input-box">
                    <van-field v-model="form.message"
                       rows="4"
                       autosize
                       label="通知"
                       type="textarea"
                       maxlength="50"
                       placeholder="请输入通知内容"
                       show-word-limit
                       class="message"
                       size="large"
                       label-width="1.2rem"
                    ></van-field>
                </div>
            </div>
        </div>
        <div class="footer">
            <van-button class="mvbutton" type="primary" size="large" color="#5D97FF" @click="go">确认发布</van-button>
        </div>
        <van-overlay :show="show">
            <div class="wrapper">
                <van-loading size="24px" type="spinner" color="#1989fa" vertical>上传中...</van-loading>
            </div>
        </van-overlay>



    </div>
</template>
<script>
    import './index.less'
    import {Uploader, Image, Overlay, Loading, Picker, Popup, Field,Button} from 'vant';
    import MyVideo from '@/components/video'
    import {mapMutations,mapState} from 'vuex'
    export default {
        name: "signup",
        computed: {
            ...mapState({
                storeuserInfo: state => state.user.userInfo
            })
        },
        data() {
            return {
                cgid: '',
                caid: '',
                show: false,
                showkey: false,
                showrule:false,
                fileList: [],
                mediaurl: '',
                id: '',
                d: 0,
                file: '',
                userInfo: '',
                dataURL:'',
                firstFlag:false,
                codeurl:'',
                types:[],
                form:{message:""},
                showPicker:false,
                ids:""
            }
        },
        components: {
            vanPicker: Picker,
            vanImage: Image,
            vanOverlay: Overlay,
            vanPopup: Popup,
            vanLoading: Loading,
            vanField:Field,
            vanUploader:Uploader,
            MyVideo,vanButton:Button
        },
        methods: {
            ...mapMutations([
                'setUserInfo'
            ]),
            onConfirm(date) {
                console.log(date)
                this.showPicker = false;
                this.form.type = date.value;
                this.form.label = date.label;
            },
            setUrl(e) {
                this.$toast.success('上传成功！');
                this.mediaurl = e
            },
            afterRead(file) {
                this.show = true
                this.$api.system.uploadfile(file).then(res => {
                    if (res.code * 1 === 200) {
                        this.show = false;
                        this.$toast.success('上传成功！');
                        this.mediaurl = res.data.url
                    }else{
                        this.$toast.error(res.message);
                    }
                });
            },
            getUserInfo() {
                this.$api.user.getUserInfo().then((res) => {
                    if (res.status * 1 === 200) {
                        this.userInfo = res.data
                        let {province, city, district, street, district_id} = res.data;
                        if (district_id) {
                            this.address = province + city + district + street
                            this.street =   street;
                        }
                    }
                })
            },


            colse(){
                this.showrule = false
                this.$router.replace({name: 'home', params: {id: this.id}})
            },
            del(){
                this.$toast.success('删除成功！');
                this.mediaurl = ''
            },
            go() {
                if (this.mediaurl == '') {
                    this.$toast.fail('请先上传证件！');
                    return;
                }
                // if (this.address == '' || this.street == '') {
                //     this.$toast.fail('请填写您的地址！');
                //     return;
                // }
                let params = this.form
                params.imgurl = this.mediaurl
                params.memids = this.ids
                this.$api.system.sendnotice(params).then((res) => {
                    if (res.status * 1 === 200) {
                        this.$toast.success('提交成功！');
                        this.$router.push('/')
                    }
                });
            },
        },
        mounted() {
           this.ids = this.$route.query.ids;
        }
    }
</script>
<style lang="less" src="./detail.less"></style>
